import SocialNetworks from './SocialNetworks'

export default SocialNetworks
